import PropTypes from 'prop-types';
import CardContainer from '@@viewCommonComponents/CardContainer.jsx';
import { CardRecap } from '@fasstech/middle-design-system';
import { getIsSelected } from '@@viewHelpers/getPropsGuarantees.js';
import { prop } from 'ramda';

const GuaranteesDeathPrevTns = ({
  getMiddleText,
  getMiddleBoolean,
  guarantees,
  PTIADeathGuarantees,
  spousePensionGuarantees,
  educationPensionGuarantees
}) => {
  const PTIADeathCard = () => {
    return (
      <CardRecap
        title={prop('title', PTIADeathGuarantees)}
        price={prop('price', PTIADeathGuarantees)}
        data={prop('options', PTIADeathGuarantees)}
      />
    );
  };

  const SpousePensionDeathCard = () => {
    return (
      <CardRecap
        title={prop('title', spousePensionGuarantees)}
        price={prop('price', spousePensionGuarantees)}
        data={prop('options', spousePensionGuarantees)}
      />
    );
  };

  const EducationPensionDeathCard = () => {
    return (
      <CardRecap
        title={prop('title', educationPensionGuarantees)}
        price={prop('price', educationPensionGuarantees)}
        data={prop('options', educationPensionGuarantees)}
      />
    );
  };

  return (
    <CardContainer
      icon="umbrella"
      iconSize={24}
      title={getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_DECES_LABEL')}
      expendable={true}>
      {((getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_TTCAUSE_EST_NECESSAIRE') &&
        getIsSelected('OPTION_TT_CAUSE', guarantees)) ||
        (getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_DECES_DECES_PTIA_ACC_EST_NECESSAIRE') &&
          getIsSelected('OPTION_ACC', guarantees))) && (
        <div className="flex gap-x-2 w-full">
          <PTIADeathCard />
        </div>
      )}
      {getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_DECES_REDUC_EST_NECESSAIRE') &&
        getIsSelected('OPTION_REDUC', guarantees) && (
        <div className="flex gap-x-2 w-full">
          <EducationPensionDeathCard />
        </div>
      )}
      {getMiddleBoolean('NIVEAUXGARANTIESETTARIFS_GAR_DECES_RCONJ_EST_NECESSAIRE') &&
        getIsSelected('OPTION_RCONJ', guarantees) && (
        <div className="flex gap-x-2 w-full">
          <SpousePensionDeathCard />
        </div>
      )}
    </CardContainer>
  );
};

GuaranteesDeathPrevTns.propTypes = {
  getMiddleText: PropTypes.func,
  getMiddleBoolean: PropTypes.func,
  guarantees: PropTypes.object,
  PTIADeathGuarantees: PropTypes.object,
  spousePensionGuarantees: PropTypes.object,
  educationPensionGuarantees: PropTypes.object
};

export default GuaranteesDeathPrevTns;
